export const statusRenderer = row => {
  return row.isActive === false || row.isActive === 'false'
    ? 'InActive'
    : 'Active'
}
